import { COMMAND_CENTER_ROOT, commandCenterPath } from './commandCenterRoutes'
import { useNavigate } from 'react-router-dom'
import { DailyMeetingsWorkroom, useDailyMeetings } from './operations/daily-meetings'

/**
 * V2 Daily Meetings — route wrapper.
 *
 * Registered standalone + auth-gated (see router.tsx):
 *   /square/command-center/operations/daily-meetings
 *
 * Owns the live data hook (useDailyMeetings) and wires navigation. The
 * workroom itself is presentational + SSR-safe. Persists to sq_daily_meetings;
 * shows honest empty / loading / auth-required / error states — never a
 * fabricated meeting. Cal.com scheduling is INTEGRATION_DEFERRED (future only).
 */
export default function SquareCodeDailyMeetingsRoute() {
  const navigate = useNavigate()
  const { meetings, loading, error, authRequired, reload, create, update } = useDailyMeetings()

  // Today's date for the create form. Browser-only; SSR renders the honest
  // loading/empty state before this route ever hydrates.
  const today = typeof window !== 'undefined' ? new Date().toISOString().slice(0, 10) : ''

  return (
    <DailyMeetingsWorkroom
      meetings={meetings}
      loading={loading}
      error={error}
      authRequired={authRequired}
      today={today}
      onCreate={create}
      onUpdate={update}
      onReload={reload}
      onHome={() => navigate(COMMAND_CENTER_ROOT)}
      onBackCommandCenter={() => navigate(COMMAND_CENTER_ROOT)}
      onBackOperations={() => navigate(commandCenterPath('operations'))}
      onOpenRoute={(to) => navigate(to)}
    />
  )
}
